<sw-card-view>
    <sw-card
        class="frosh-tools-tab-queue__manager-card"
        :title="$t('frosh-tools.tabs.queue.title')"
        :isLoading="isLoading"
        :large="true"
        positionIdentifier="frosh-tools-tab-queue"
        deprecated
    >
        <template #toolbar>
            <sw-button
                variant="ghost"
                deprecated
                @click="refresh"
            >
                <sw-icon
                    :small="true"
                    deprecated
                    name="regular-undo"
                ></sw-icon>
            </sw-button>
            <sw-button
                deprecated
                @click="showResetModal = true"
            >
                {{ $t('frosh-tools.resetQueue') }}
            </sw-button>
        </template>

        <template #grid>
            <sw-data-grid
                :showSelection="false"
                :dataSource="queueEntries"
                :columns="columns"
                :showActions="false"
            >
            </sw-data-grid>
        </template>
    </sw-card>
    <sw-modal
        v-if="showResetModal"
        :title="$t('frosh-tools.tabs.queue.reset.modal.title')"
        variant="small"
        @modal-close="showResetModal = false"
    >
        {{ $t('frosh-tools.tabs.queue.reset.modal.description') }}
        <template #modal-footer>
            <sw-button
                deprecated
                @click="showResetModal = false"
            >
                {{ $t('global.default.cancel') }}
            </sw-button>
            <sw-button
                deprecated
                @click="resetQueue"
                variant="primary"
            >
                {{ $t('frosh-tools.tabs.queue.reset.modal.reset') }}
            </sw-button>
        </template>
    </sw-modal>
</sw-card-view>